<template>
  <el-drawer v-model="visible" size="30%">
    <template #title>
      <span class="import-title">工资详情</span>
    </template>
    <div class="main-center">
      <el-descriptions :column="1" border width="150px">
        <el-descriptions-item v-for="column in columns1" :key="column.key" :label="column.label" label-class-name="label-width-100">
          {{ wageSlip[column.key] }}
        </el-descriptions-item>
        <el-descriptions-item label="应扣工资：">
          <el-descriptions :column="1" width="150px">
            <el-descriptions-item v-for="column in columns2" :key="column.key" :label="column.label">
            {{ wageSlip[column.key] }}
          </el-descriptions-item>
          </el-descriptions>
        </el-descriptions-item>
        <el-descriptions-item v-for="column in columns3" :key="column.key" :label="column.label">
          {{ wageSlip[column.key] }}
        </el-descriptions-item>
        <el-descriptions-item label="项目标签：">
          {{ wageSlip.projectName }}
          {{ wageSlip.teamName ? "/" + wageSlip.teamName : "" }}
          {{ wageSlip.groupName ? "/" + wageSlip.groupName : "" }}
        </el-descriptions-item>
      </el-descriptions>

      <div class="timeline" style="padding: 20px 0px">
        <el-timeline>
          <el-timeline-item :key="wageSlip.id" :icon="UploadFilled" type="primary" color="#0bbd87"
            size="large" :hollow="true" :timestamp="'上传'" placement="top">
            <div>{{ wageSlip.createUserName }}</div>
            <div>{{ wageSlip.createTimeString }}</div>
          </el-timeline-item>
          <el-timeline-item v-if="wageSlip.sendTime" :key="wageSlip.id" :icon="Promotion" type="primary"
            color="#0bbd87" size="large" :hollow="true" :timestamp="'发送'" placement="top">
            <div>{{ wageSlip.sendUserName }}</div>
            <div>{{ wageSlip.sendTimeString }}</div>
          </el-timeline-item>
          <el-timeline-item v-if="wageSlip.sureTime" :key="wageSlip.id" :icon="CircleCheckFilled" type="primary"
            color="#0bbd87" size="large" :hollow="true" :timestamp="'确认'" placement="top">
            <div>
              <div>
                <el-image style="width: 100px; height: 100px" :src="getFileUrl(wageSlip.photoPath)"
                  :preview-src-list="[getFileUrl(wageSlip.photoPath)]" fit="cover">
                </el-image>
              </div>
              <div>
                {{ wageSlip.sureOpinion ? "意见：" + wageSlip.sureOpinion : ""}}
              </div>
            </div>
            <div>{{ wageSlip.sureTimeString }}</div>
          </el-timeline-item>
          <el-timeline-item v-if="wageSlip.auditTime" :key="wageSlip.id" :icon="Unlock" type="primary"
            color="#0bbd87" size="large" :hollow="true" :timestamp="'审核'" placement="top">
            <div>{{ wageSlip.auditUserName }}</div>
            <div>
              {{ wageSlip.auditOpinion ? "意见：" + wageSlip.auditOpinion : "" }}
            </div>
            <div>{{ wageSlip.auditTimeString }}</div>
          </el-timeline-item>
          <el-timeline-item v-if="wageSlip.grantTime" :key="wageSlip.id" :icon="Collection" type="primary"
            color="#0bbd87" size="large" :hollow="true" :timestamp="'发放'" placement="top">
            <div>{{ wageSlip.grantUserName }}</div>
            <div>{{ wageSlip.grantTimeString }}</div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <template #footer>
      <div style="flex: auto">
        <el-button @click="visible = false">关闭</el-button>
      </div>
    </template>
  </el-drawer>
</template>
<script>
import { defineComponent, shallowRef } from "vue";
import { UploadFilled, Promotion, CircleCheckFilled, Unlock, Collection } from "@element-plus/icons-vue";
import { getFileUrl } from "@/utils/common";
export default defineComponent({
  emits: ["update:modelValue"],
  data() {
    return {
      UploadFilled: shallowRef(UploadFilled),
      Promotion: shallowRef(Promotion),
      CircleCheckFilled: shallowRef(CircleCheckFilled),
      Unlock: shallowRef(Unlock),
      Collection: shallowRef(Collection),
      getFileUrl,
      columns1: [
        { label: '姓名：', key: 'name' },
        { label: '身份证号：', key: 'idCardNo' },
        { label: '银行：', key: 'bankName' },
        { label: '银行卡号：', key: 'bankCardNo' },
        { label: '开户行：', key: 'bankDeposit' },
        { label: '工种：', key: 'typeOfWorkName' },
        { label: '应发工资：', key: 'shouldPaySalary' }
      ],
      columns2: [
        { label: '社保扣除：', key: 'socialAccountDeduction' },
        { label: '个税扣除：', key: 'individualIncomeTax' },
        { label: '其他扣除：', key: 'otherDeduction' }
      ],
      columns3: [
        { label: '实发工资：', key: 'actualSalary' },
        { label: '备注：', key: 'remarks' },
        { label: '电话：', key: 'phone' }
      ]
    };
  },
  props: {
    modelValue: Boolean,
    wageSlip: Object,
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
});
</script>
<style lang="scss" scoped>
.import-title {
  font-weight: bold;
  color: #2483c6;
  font-size: 1.5em;
}
</style>